// remove overflow hidden back when cart is closed
$(document).ready(function() {
    var $body = $('body');

    // Check every 100ms if cart class is removed
    setInterval(function() {
        if (!$body.hasClass('rebuy-cart-visible') && $body.css('overflow') === 'hidden') {
            $body.css('overflow', ''); // remove overflow hidden
        }
    }, 100);
});